
import { defineComponent, ref } from 'vue'
import { addMessage } from '@/services/messages'

export default defineComponent({
  name: 'InputBox',
  setup() {
    const newMessage = ref('')

    const updateMessage = (event: Event) => {
      const htmlInput = event.target as HTMLInputElement

      if (!htmlInput) return

      newMessage.value = (event.target as HTMLInputElement).value
    }

    const onSubmit = function(event: Event) {
      const htmlInput = event.target as HTMLInputElement

      addMessage(newMessage.value, 'input')
      htmlInput.value = ''
    }

    return { addMessage, newMessage, updateMessage, onSubmit }
  }
})
